import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-pk10-houwu',
  templateUrl: './pk10-houwu.component.html',
  styleUrls: ['./pk10-houwu.component.css']
})
export class Pk10HouwuComponent implements OnInit {

  @ViewChild('HouWuTrendLine') houwu_trend_line_ref: ElementRef;

  @Input()
  public auxs: Array<any>;

  @Input()
  public issue_num: string;

  @Input()
  public trend_data: Array<any>;

  @Input()
  public analysis_data: Array<any> = [];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.draw_trend_line_handler();
  }


  /**
   * 走势线
   *
   * @memberof Pk10HouwuComponent
   */
  public draw_trend_line_handler() {
    // 设置canvas高度
    this.houwu_trend_line_ref.nativeElement.width = 800;
    this.houwu_trend_line_ref.nativeElement.height = this.trend_data.length * 30;

    const houwu_cxt: CanvasRenderingContext2D = this.houwu_trend_line_ref.nativeElement.getContext('2d');

    let w: number = 800;
    let h: number = this.trend_data.length * 30;
    houwu_cxt.fillStyle = 'rgba(255, 255, 255, 0)';
    houwu_cxt.clearRect(0, 0, w, Number(this.issue_num) * 30);
    houwu_cxt.fillRect(0, 0, w, h);

    for (let i = 5; i < 10; i++) {
      houwu_cxt.beginPath();

      for (let j = 0; j < this.trend_data.length - 1; j++) {
        let win_num_1 = Number(this.trend_data[j].lottery[i]);
        let win_num_2 = Number(this.trend_data[j + 1].lottery[i]);

        let cell_w = 16;
        let cell_h = 30;

        let x1: number = (cell_w * 10 * (i - 5)) + (Number(win_num_1) - 1) * cell_w + cell_w / 2;
        let y1: number = (j * cell_h) + cell_h / 2;

        let x2: number = (cell_w * 10 * (i - 5)) + (Number(win_num_2) - 1) * cell_w + cell_w / 2;
        let y2: number = ((j + 1) * cell_h) + cell_h / 2;

        houwu_cxt.lineWidth = 1;
        houwu_cxt.strokeStyle = '#FF5656';

        houwu_cxt.moveTo(x1, y1);
        houwu_cxt.lineTo(x2, y2);
        houwu_cxt.stroke();
      }

      houwu_cxt.closePath();
    }
  }

}
